import { ref, computed } from '@vue/composition-api';
import { togglePanelShow } from '../components/ContentSection/Outline/useOutline';

const activeWorkspaceId = ref(null);

const pageToPin = ref(null);

const workspace = ref({
  activePane: 0,
  panes: [
    {
      id:
        '_' +
        Math.random()
          .toString(36)
          .substr(2, 9),
      size: 100,
      activeTab: null,
      tabs: []
    }
  ]
});

const openedTabs = computed(() => {
  const panes = workspace.value.panes;
  const tabs = [];
  panes.forEach(p => {
    p.tabs.forEach(t => {
      tabs.push(t);
    });
  });
  return tabs;
});

console.log(workspace);

export default function useContext() {
  const createPane = ({ pageId = pageToPin.value, index = null, parentPageId, parentNoteId }) => {
    const newId =
      '_' +
      Math.random()
        .toString(36)
        .substr(2, 9);
    const tabId =
      '_' +
      Math.random()
        .toString(36)
        .substr(2, 9);

    const newPane = {
      id: newId,
      size: null,
      activeTab: 0,
      tabs: [
        {
          id: tabId,
          pageId,
          parentPageId,
          parentNoteId
        }
      ]
    };
    if (index == null) {
      workspace.value.panes.push(newPane);
    } else {
      workspace.value.panes.splice(index, 0, newPane);
    }
    setPageToPin(null);
    return newId;
  };

  const removePane = ({ paneId }) => {
    const index = workspace.value.panes.findIndex(p => p.id == paneId);
    workspace.value.panes.splice(index, 1);
  };

  const setPageToPin = pageId => {
    pageToPin.value = pageId;
  };

  const openInTab = ({
    pageId,
    paneId,
    tabId = null,
    toggle = true,
    parentPageId,
    parentNoteId
  }) => {
    console.log(parentPageId, parentNoteId);
    if (!pageId) {
      return Error('no page id');
    }

    //  check if sceen size is small, if so, make sure panel is closed
    if (window.innerWidth < 960) {
      togglePanelShow(false);
    }

    let pId = paneId;
    if (!pId) {
      //  put it in the first one
      pId = workspace.value.panes[0].id;
    }
    const index = workspace.value.panes.findIndex(p => p.id == pId);
    let tabIndex = null;
    if (tabId && workspace.value.panes[index].tabs.length) {
      //  replacing content in a certain tab
      console.log(workspace.value.panes[index].activeTab, tabId, workspace.value);
      tabIndex =
        tabId == 'active' || tabId == 'outline'
          ? workspace.value.panes[index].activeTab
          : workspace.value.panes[index].tabs.findIndex(t => t.id == tabId);
      workspace.value.panes[index].tabs[tabIndex].pageId = pageId;
      workspace.value.panes[index].tabs[tabIndex].parentPageId = parentPageId;
      workspace.value.panes[index].tabs[tabIndex].parentNoteId = parentNoteId;
    } else {
      const tabId =
        '_' +
        Math.random()
          .toString(36)
          .substr(2, 9);
      workspace.value.panes[index].tabs.push({ pageId, id: tabId, parentPageId, parentNoteId });
      tabIndex = workspace.value.panes[index].tabs.length - 1;
    }
    console.log(tabIndex);
    if (toggle) {
      workspace.value.panes[index].activeTab = tabIndex;
    }
  };

  const findPaneIndex = paneId => {
    return workspace.value.panes.findIndex(p => p.id == paneId);
  };
  const findTabIndex = (paneId, tabId) => {
    const pane = workspace.value.panes.find(p => p.id == paneId);
    return pane.tabs.findIndex(t => t.id == tabId);
  };

  const closeTab = ({ tabId, paneId }) => {
    //  if multiple tabs, remove
    //  or if only pane, just remove
    const paneIndex = findPaneIndex(paneId);
    const pane = workspace.value.panes[paneIndex];
    if (workspace.value.panes.length == 1 || pane.tabs.length > 1) {
      const tabIndex = findTabIndex(paneId, tabId);
      //  if last tab, update the active tab to previous
      if (pane.tabs.length > 1 && tabIndex == pane.tabs.length - 1) {
        workspace.value.panes[paneIndex].activeTab = tabIndex - 1;
      } else {
        workspace.value.panes[paneIndex].activeTab = null;
      }
      workspace.value.panes[paneIndex].tabs.splice(tabIndex, 1);
    } else {
      workspace.value.panes.splice(paneIndex, 1);
    }
  };

  const setActiveWorkspaceId = id => {
    activeWorkspaceId.value = id;
  };

  return {
    workspace,
    activeWorkspaceId,
    setActiveWorkspaceId,
    pageToPin,
    createPane,
    removePane,
    openInTab,
    closeTab,
    openedTabs
  };
}
